import { Skeleton } from '@nexelem/components';

const SimulationLotSummarySkeletonItem = () => (
  <div className="flex items-center gap-2 rounded-xs border border-border-container px-2 py-3">
    <div className="flex items-center justify-end gap-2">
      <Skeleton className="size-7 rounded-full" />
      <Skeleton className="size-7 rounded-full" />
    </div>
    <div className="flex flex-col gap-1">
      <Skeleton className="h-3 w-62" />
      <Skeleton className="h-4.5 w-75" />
      <Skeleton className="h-3 w-62" />
    </div>
    <div className="mr-14 ml-auto">
      <Skeleton className="h-4.5 w-18" />
    </div>
  </div>
);

type SimulationLotSummarySkeletonProps = {
  count?: number;
};

export const SimulationLotSummarySkeleton = ({ count = 3 }: SimulationLotSummarySkeletonProps) => (
  <div className="flex w-full flex-col gap-3">
    {Array.from({ length: count }).map((_, index) => (
      <SimulationLotSummarySkeletonItem key={`summary-skeleton-${index}`} />
    ))}
  </div>
);
